import { render, staticRenderFns } from "./MainPageInstituteList.vue?vue&type=template&id=45da9ce9&"
import script from "./MainPageInstituteList.vue?vue&type=script&lang=js&"
export * from "./MainPageInstituteList.vue?vue&type=script&lang=js&"
import style0 from "./MainPageInstituteList.vue?vue&type=style&index=0&id=45da9ce9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports